import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useReactToPrint } from 'react-to-print';

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData,setPackage} from '../../../Redux/actions/packageActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import QRCode from "react-qr-code";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;


const MODAL_BLUEPRINT=[
  {
    title: 'Shipping method',
    key: 'shipping_method',  
    type: 'fixed-options',
    choices:[
      { value: 'grab', label: 'Grab' },
      { value: 'lalamove', label: 'Lalamove' },   
      { value: 'transportify', label: 'Transportify' },  
      { value: 'self', label: 'Self' },  
    ], 
    rules:{
      required:true   
    }   
  },
  {
    title: 'shipping_method_name',
    key: 'shipping_method_name',  
    type: 'hidden',  
  },
  {
    title: 'Driver Name',
    key: 'shipping_driver',
    type: 'text', 
    rules:{
      required:true   
    }    
  },
  {
    title: 'Driver Contact',
    key: 'shipping_contact',
    type: 'number', 
    rules:{
      required:true   
    }    
  },
  {
    title: 'Plate Number',
    key: 'shipping_plate',
    type: 'text', 
    rules:{
      required:true   
    }    
  },

  {
    title: 'Shipping Fee',
    key: 'shipping_fee',
    type: 'number', 
    rules:{
      required:true   
    }    
  },
  {
    title: 'Shipping Url',
    key: 'shipping_url',
    type: 'text', 
    rules:{
      required:true   
    }    
  },



]


const Index = ({currentItem,onCloseModal}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,locations } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations 
    }), shallowEqual)

    const componentRef = useRef();
    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)
    const [formSubmitClick, setFormSubmitClick] = useState(false)


    const [destination, setDestination] = useState(null)
    const [destinationName, setDestinationName] = useState(null)
    const [packItems, setPackItems] = useState([])



    useEffect(() => {
 
    },[]);


    const saveChanges = (form) =>{ 
   
      setLoading(true)
      if(form.errorFields){
        form.errorFields.map(er=>{
          er.errors.map(err=>{
            message.error(err)
          })
        })
        setLoading(false)   
      }else{
        
        console.log(form)
        var newForm ={
          ...form,
          status: 'shipping',
          shipped_at: moment().format('YYYY-MM-DD HH:mm:ss'),      
          shipped_by:user.id,
          shipped_name:user.name,  
        }
        dispatch(setPackage(newForm,currentItem.id))
        .then(res=>{
          message.success('Package Shipped')
          setLoading(false)  
          setIsModalVisible(false);       
          onCloseModal()
        })
        .catch(err=>{
          setLoading(false)  
          setIsModalVisible(false);       
          onCloseModal()
        })

      }
      
    }


        
    const footer = () =>{

      var schema= {
        title: 'Destination',
        key: 'destionation',
        type: 'options',   
        api:'locations', 
        prevent_recursion:true,
      }
      var current={
        id: user.branch
      }
  
      return(
        <div >    
       
          <Button type="primary" loading={loading} onClick={()=>{setFormSubmitClick(true)}} >
            Ship Package
          </Button>   
   
        </div>
      )
     
    }

    
    const closeModal = (action) =>{
      if(!loading){
        setPackItems([])
        setIsModalVisible(false);       
        onCloseModal()
      }
    }

    return(       
      <div  onClick={(e)=>{e.preventDefault();e.stopPropagation()}}>

      <div className={'scanButton'}>
        <Button onClick={(e)=>{e.preventDefault();e.stopPropagation();setIsModalVisible(true)}} type={'primary'} >Ship</Button>
      </div>

     
      {isModalVisible?  
        <Modal title={'Ship Package:' + currentItem.id}   visible={isModalVisible} footer={footer()}  onCancel={()=>{closeModal()}}  onClick={(e)=>{e.preventDefault();e.stopPropagation()}}>
          <div className="cart-content">
            {currentItem.dest ?
            <div> 
              <Divider orientation="left">Reciever Details</Divider>
              <div className={'desc'}>
                <span className={'label'}>Contact Person: </span> <span className={'val'}>{currentItem.dest.contact_person}</span>
              </div>
              <div className={'desc'}>
                <span className={'label'}>Contact No: </span> <span className={'val'}>{currentItem.dest.contactno}</span>
              </div >
              <div className={'desc'}>
                <span className={'label'}>Destination: </span> <span className={'val'}>{currentItem.dest.name}</span>
              </div>
              <div className={'desc'}> 
                <span className={'label'}>Address: </span> <span className={'val'}>{currentItem.dest.address}</span>
              </div>
              <Divider />
            </div>
            :null}
          
          <CreateForm  currentItem={currentItem}  blueprint={MODAL_BLUEPRINT}  saveForm={(e)=>{saveChanges(e); setFormSubmitClick(false)}} FormSubmitClick={formSubmitClick} /> 
          </div>
        </Modal>
        :null}
      </div>
    )
}
  
export default Index
  